import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useBalanceSheets(id) {
  const { data, error, isLoading } = useSWRImmutable(`/react/balance_sheets/history?stock_id=${id}`, fetcher)

  return {
    balanceSheets: data,
    isLoading,
    error
  }
}